// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1rMyv","content":"Consent_content__tHJ0w","footer":"Consent_footer__3vH0r"};